import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { SeniorCheck } from '../survey-answers';

export const UpdateProspectSeniorCheckParameters = z.object({
  userId: HealthcareUserId,
  sessionId: HealthcareSessionId,
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
  seniorCheck: SeniorCheck,
});

// eslint-disable-next-line no-redeclare
export type UpdateProspectSeniorCheckParameters = z.infer<
  typeof UpdateProspectSeniorCheckParameters
>;
